import {Component} from '@angular/core';
import {TabsService} from "../../../services/tabsService";
import {MapService} from "../../../services/map.service";
import {GritApiService} from "../../../services/grit/grit.api.service";
import {CoordenateService} from "../../../services/coordenate.service";
import {PointsService} from "../../../services/points.service";
import {ModalConfirmationService} from "../../../services/modal-confirmation.service";
import {UiBlockService} from "../../../services/ui-block.service";
import {ModalControlService} from "../../../services/modal-control.service";
import {toLonLat} from "ol/proj";
import {GritRadarService} from "../../../services/grit/grit.radar.service";
import {GritProjectService} from "../../../services/grit/grit.project.service";
import {FeatureType} from "../../../models/EnumTypes";
import {fromCircle} from "ol/geom/Polygon";
import Circle from "ol/geom/Circle";
import * as olProj from "ol/proj";
import {GritUserRoleGroup, GritUserService} from "../../../services/grit/grit.user.service";
import { RadarModel } from 'src/app/models/grit/grit.radar-model';
import { GritGroupsComponent } from 'src/app/utils/grit/grit-groups/grit-groups.component';


@Component({
  selector: 'app-radar',
  templateUrl: './radar.component.html',
  styleUrls: ['./radar.component.scss'],
  standalone: false
})
export class RadarComponent {

  readonly groupsNotNull = GritGroupsComponent.groupsNotNull;

  constructor(public radarService: GritRadarService,
              public tabsService: TabsService,
              private mapService:MapService,
              private gritAPIService:GritApiService,
              private rcsControl: CoordenateService,
              private pointsService: PointsService,
              private modalConfirmation: ModalConfirmationService,
              private uiBlock: UiBlockService,
              private projectService : GritProjectService,
              protected gritUserService : GritUserService,
              private modalService: ModalControlService) {

    this.mapService.getMap('map').on("dblclick", this.dblClickHandler.bind(this));
  }

  dblClickHandler(evt) {
    var coords = toLonLat(evt.coordinate,this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857");
    this.radarService.detailsTab.selected.latitude.value = coords[1];
    this.radarService.detailsTab.selected.longitude.value = coords[0];
  }

  async submit(created: boolean){
    let radar = this.radarService.detailsTab.selected
    const projection = this.mapService.getMaps().getView().getProjection();
    let geometry = new Circle(
      olProj.fromLonLat([radar.longitude.value, radar.latitude.value], projection),
      RadarModel.getCircleRadiusForProjection(radar.radius * 1000, projection))

    radar.firs = await this.projectService.getFir(fromCircle(geometry, 64))

    let config = {
      title: "Save Radar",
      titleSuccess: "Radar Saved",
      message: created ?
        "Create new radar? All the information will be saved in the GRIT Database." :
        "You are editing a published radar, do you wish to continue and save the changes?",
      messageSuccess: created ?
        "The Radar was created sucessfully!" :
        "The Radar was edited sucessfully!",
      endpoint: created ?
        this.gritAPIService.radarCreate.bind(this.gritAPIService, radar) :
        this.gritAPIService.radarUpdate.bind(this.gritAPIService, [radar])
    }

    this.modalConfirmation.showMesssageConfirmationModal(
      config.title,
      config.message,
      "OK", "Cancel",
      () => {
        this.uiBlock.startBlock("Saving Radar...")

        return config.endpoint().then(
          (radars) => {

            //Map
            this.pointsService.addRadarsToMap(radars);

            this.modalService.showMesssageModal(config.titleSuccess, config.messageSuccess);
            this.tabsService.closeTab()
          },
          (response) => {
            let message : string  = '';
            response['error']['errors'].map(error => message += `${error['message']};\n`);
            this.modalService.showMesssageModal('Error Saving RFI-Transmitter', message);
          }
        ).finally(() => this.uiBlock.stopBlock());
      }
    );
  }

  protected readonly GritUserRoleGroup = GritUserRoleGroup;
}
